// App.js - Composant principal
import React, { useState, useEffect } from 'react';
import Footer from '../components/Navbar/Footer';


import LogoOut from '../Dashboard/LogoOut';
import UpPassWord from '../components/Formulaires/UpPassWord';
import NavbarADM from '../components/Navbar/NavbarADM';
import SidebarADM from '../components/Sidebar/SidebarADM';



function SettingsPagesADM({userId,tel}) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
 

  // Détection de la taille d'écran pour le mode mobile
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="app">
      <SidebarADM 
        isOpen={sidebarOpen} 
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />
      <div className="main-content">
        <NavbarADM
        tel={tel}
          toggleSidebar={toggleSidebar}
          isMobile={isMobile}
        />
         <h1 style={{textAlign:'center', padding:'20px'}}>PARAMETRES</h1>

         <UpPassWord id={userId}  />
         <LogoOut  />
      
      </div>
    </div>
  );
}

export default SettingsPagesADM;